import 'media-chrome';
import { MediaThemeElement } from 'media-chrome/dist/media-theme-element.js';
const templateElement = document.createElement('template');
const volumeIcon = `<svg width="17" height="17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.2.737 3.495 5.48a.232.232 0 0 1-.144.056H1.6a1.6 1.6 0 0 0-1.6 1.6v2.736a1.6 1.6 0 0 0 1.6 1.6h1.752a.192.192 0 0 1 .144.056l4.703 4.735a.8.8 0 0 0 1.368-.56V1.305A.8.8 0 0 0 8.2.737ZM14.071 2.905a.8.8 0 1 0-1.136 1.127 6.35 6.35 0 0 1 0 8.992.8.8 0 1 0 1.136 1.128 7.96 7.96 0 0 0 0-11.247Z" fill="var(--media-icon-color)"/><path d="M12.111 4.904a.8.8 0 0 0-1.136 1.128 3.504 3.504 0 0 1 0 4.944.8.8 0 1 0 1.136 1.128 5.096 5.096 0 0 0 0-7.2Z" fill="var(--media-icon-color)"/></svg>`;
templateElement.innerHTML = /* html */ `
  <style>
    :host {
      --media-control-padding: none;
      --media-control-background: none;
      --media-control-hover-background: none;

      --media-time-range-buffered-color: rgba(var(--color-on-background-rgb, 0, 0, 0), 0.1);

      --media-range-track-background: rgba(var(--color-on-background-rgb, 0, 0, 0), 0.1);
      --media-range-track-height: 4px;
      --media-range-thumb-height: 16px;
      --media-range-thumb-width: 16px;
      --media-range-thumb-background: var(--color-on-background, #000000);
      --media-range-bar-color: var(--color-on-background, #000000);

      --media-icon-color: var(--color-on-background, #000000);

      --media-text-color: rgba(var(--color-on-background-rgb, 0, 0, 0), 0.6);

      --media-font-size: 14px;
      --media-font-family: var(--font-family-base, sans-serif);

      --media-preview-time-text-shadow: none;
      --media-preview-time-background: var(--color-on-background, #000000);
      --media-preview-time-margin: 0 0 15px;

      position: absolute;
      top: 0;
      bottom: 0;
    }

    *[role=button]:hover {
      --media-icon-color: var(--color-primary, #000000);
    }

    media-controller {
      background: none;
    }

    media-play-button {
      position: absolute;
      top: 40px;
      left: 50%;

      transform: translateX(-50%);

      @media (min-width: 640px) {
        top: 75px;
      }
    }

    media-seek-forward-button {
      position: absolute;
      top: 40px;
      right: 50%;

      transform: translateX(calc(100% + 55px));

      @media (min-width: 640px) {
        top: 75px;
      }
    }

    media-seek-backward-button {
      position: absolute;
      top: 40px;
      left: 50%;

      transform: translateX(calc(-100% - 55px));

      @media (min-width: 640px) {
        top: 75px;
      }
    }

    media-time-range {
      --media-text-color: var(--color-background, #ffffff);

      position: absolute;
      right: 20px;
      bottom: 24px;
      left: 20px;

      width: auto;

      @media (min-width: 640px) {
        right: 140px;
        bottom: 12px;
        left: 70px;
      }
    }

    media-time-display {
      position: absolute;
      bottom: 36px;
      left: 20px;

      @media (min-width: 640px) {
        bottom: 0px;
      }
    }

    media-duration-display {
      position: absolute;
      right: 20px;
      bottom: 36px;

      @media (min-width: 640px) {
        right: 85px;
        bottom: 0px;
      }
    }

    media-playback-rate-button {
      position: absolute;

      display: block;

      top: 20px;
      left: 20px;

      font-weight: 400;

      @media (min-width: 640px) {
        top: unset;
        left:unset;
        right: 44px;
        bottom: 0px;

        text-align: center;
      }
    }

    media-airplay-button {
      --media-icon-color: rgba(var(--color-on-background-rgb, 0, 0, 0), 0.6);

      position: absolute;
      top: 20px;
      right: 24px;
    }

    media-mute-button {
      --media-icon-color: rgba(var(--color-on-background-rgb, 0, 0, 0), 0.6);

      position: absolute;
      right: 24px;
      bottom: 4px;

      display: none;

      @media (min-width: 640px) {
        display: flex;
      }
    }

    .media-volume-range-container {
      position: absolute;
      right: -18px;
      bottom: 16px;

      display: none;

      padding-bottom: 75px;
    }

    media-volume-range {
      --media-range-track-width: 70px;

      transform: rotate(-90deg);
    }

    media-mute-button:hover + .media-volume-range-container,
    .media-volume-range-container:hover {
      display: flex;
    }
  </style>

  <media-controller audio defaultduration="{{defaultduration}}">
    <slot name="media" slot="media"></slot>

    <media-time-range></media-time-range>

    <media-seek-backward-button seekoffset="15">
      <div slot="icon">
        <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#a)"><path d="m17 2-3 3 3 3" stroke="var(--media-icon-color)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M2.667 18a13 13 0 1 0 13-13h-1" stroke="var(--media-icon-color)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.16 22v-6.804H9.144v-.744c1.248-.048 1.884-.204 2.364-1.152h.744V22H11.16Zm8.786-2.856c0-1.44-1.008-2.064-1.956-2.064-.9 0-1.488.528-1.68.96l-1.092-.06.564-4.68h4.992v1.02H16.67l-.3 2.472c.456-.444 1.152-.66 1.872-.66 1.524 0 2.856 1.08 2.856 3 0 1.992-1.476 3.024-3.096 3.024-2.016 0-2.928-1.272-3.096-2.676h1.128c.168 1.092.756 1.764 1.968 1.764 1.044 0 1.944-.756 1.944-2.1Z" fill="var(--media-icon-color)"/></g><defs><clipPath id="a1"><path fill="var(--media-icon-color)" transform="rotate(90 16 16)" d="M0 0h32v32H0z"/></clipPath></defs></svg>
      </div>
    </media-seek-backward-button>

    <media-seek-forward-button seekoffset="15">
      <div slot="icon">
        <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#a)"><path d="m15 2 3 3-3 3" stroke="var(--media-icon-color)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M29.334 18a13 13 0 1 1-13-13h1" stroke="var(--media-icon-color)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.16 22v-6.804h-2.016v-.744c1.248-.048 1.884-.204 2.364-1.152h.744V22H12.16Zm8.786-2.856c0-1.44-1.008-2.064-1.956-2.064-.9 0-1.488.528-1.68.96l-1.092-.06.564-4.68h4.992v1.02H17.67l-.3 2.472c.456-.444 1.152-.66 1.872-.66 1.524 0 2.856 1.08 2.856 3 0 1.992-1.476 3.024-3.096 3.024-2.016 0-2.928-1.272-3.096-2.676h1.128c.168 1.092.756 1.764 1.968 1.764 1.044 0 1.944-.756 1.944-2.1Z" fill="var(--media-icon-color)"/></g><defs><clipPath id="a2"><path fill="var(--media-icon-color)" transform="matrix(0 1 1 0 0 0)" d="M0 0h32v32H0z"/></clipPath></defs></svg>
      </div>
    </media-seek-forward-button>

    <media-play-button>
      <div slot="play" style="display:flex;">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none"><path d="M29.988 15.553a.5.5 0 0 1 0 .894L1.224 30.83a.5.5 0 0 1-.724-.447V1.618a.5.5 0 0 1 .724-.447l28.764 14.382Z" fill="var(--media-icon-color)" stroke="var(--media-icon-color)"/></svg>
      </div>
      <span slot="pause" style="display:flex;">
        <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 0h8v32H4V0ZM20 0h8v32h-8V0Z" fill="var(--media-icon-color)"/></svg>
      </span>
    </media-play-button>

    <media-mute-button>
      <div style="display:flex;" slot="high">${volumeIcon}</div>
      <div style="display:flex;" slot="medium">${volumeIcon}</div>
      <div style="display:flex;" slot="low">${volumeIcon}</div>
      <div style="display:flex;" slot="off">
        <svg width="18" height="17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m5.63 4.808-.65.672a.223.223 0 0 1-.14.056H3.13c-.414 0-.81.169-1.104.469a1.62 1.62 0 0 0-.457 1.131v2.736c0 .424.165.831.457 1.131.293.3.69.469 1.104.469h1.71a.183.183 0 0 1 .14.056l4.59 4.735a.763.763 0 0 0 .85.177.786.786 0 0 0 .35-.293.815.815 0 0 0 .134-.444V9.227l-5.273-4.42ZM6.188 4.231l4.716 3.952V1.305a.814.814 0 0 0-.13-.447.785.785 0 0 0-.351-.297.763.763 0 0 0-.854.176L6.19 4.23ZM12.575 10.627a3.49 3.49 0 0 1-.297.349.81.81 0 0 0 .254 1.303.764.764 0 0 0 .854-.175c.143-.147.276-.301.399-.462l-1.21-1.015ZM14.222 10.964l-1.241-1.04a3.577 3.577 0 0 0-.703-3.892.801.801 0 0 1-.227-.566.816.816 0 0 1 .23-.566.78.78 0 0 1 .554-.232.765.765 0 0 1 .551.236 5.16 5.16 0 0 1 1.453 3.6c0 .868-.216 1.713-.617 2.46ZM14.712 12.418c-.161.213-.335.415-.521.606a.81.81 0 0 0 .253 1.303.764.764 0 0 0 .855-.175c.222-.228.43-.47.621-.72l-1.208-1.014Z" fill="var(--media-icon-color)"/><path d="m16.375 12.769-1.22-1.023a6.49 6.49 0 0 0 .382-5.652 6.363 6.363 0 0 0-1.347-2.061.81.81 0 0 1 .255-1.304.764.764 0 0 1 .854.176 8.061 8.061 0 0 1 2.27 5.623c0 1.513-.42 2.98-1.194 4.24Z" fill="var(--media-icon-color)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M17.18 15.797a1 1 0 0 1-1.409.124L.358 3a1 1 0 0 1 1.284-1.533l15.414 12.921a1 1 0 0 1 .124 1.41Z" fill="var(--media-icon-color)"/></svg>
      </div>
    </media-mute-button>

    <div class="media-volume-range-container">
      <media-volume-range></media-volume-range>
    </div>

    <media-time-display notoggle></media-time-display>

    <media-duration-display></media-duration-display>

    <media-playback-rate-button rates="0.25 0.5 0.75 1 1.25 1.5 1.75 2" ></media-playback-rate-button>

    <media-airplay-button>
      <div slot="icon">
        <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#a)" fill="var(--media-icon-color)"><path d="M8.28 9.996a.373.373 0 0 0-.56 0l-4.746 5.466a.325.325 0 0 0 .24.538h9.573a.325.325 0 0 0 .24-.538L8.28 9.996Z"/><path d="m10.223 10.782.137-.11a3.556 3.556 0 1 0-4.693 0l.147.12a.08.08 0 0 0 .092.02.08.08 0 0 0 .028-.02L6 10.666l.382-.445a.072.072 0 0 0 .016-.079.072.072 0 0 0-.016-.023 2.666 2.666 0 1 1 3.25 0 .076.076 0 0 0 0 .107l.377.444.089.098a.08.08 0 0 0 .124.013Z"/><path d="m11.636 12.484.053-.04a5.778 5.778 0 1 0-7.378 0l.036.027a.09.09 0 0 0 .124 0L4.89 12l.07-.08a.067.067 0 0 0 .001-.093l-.045-.031a4.889 4.889 0 1 1 6.223 0l-.063.048a.063.063 0 0 0-.015.073.063.063 0 0 0 .015.02l.063.072.395.444.036.04a.063.063 0 0 0 .066-.009Z"/><path d="M8 0a8 8 0 0 0-5.137 14.129l.035.031a.089.089 0 0 0 .125 0l.026-.031.41-.476.026-.03a.093.093 0 0 0 0-.13l-.049-.035a7.111 7.111 0 1 1 9.107.03h-.027a.07.07 0 0 0 0 .094l.022.022.445.534a.071.071 0 0 0 .093 0A8 8 0 0 0 8.001 0Z"/></g><defs><clipPath id="a3"><path fill="var(--media-icon-color)" d="M0 0h16v16H0z"/></clipPath></defs></svg>
      </div>
    </media-airplay-button>
  </media-controller>
`;
class MediaThemeFourthwallAudio extends MediaThemeElement {
    static template = templateElement;
}
if (!globalThis.customElements.get('media-theme-fourthwall-audio')) {
    globalThis.customElements.define('media-theme-fourthwall-audio', MediaThemeFourthwallAudio);
}
export default MediaThemeFourthwallAudio;
